<script setup lang="ts">
import type { NovaBoxAuctionCardProps } from './NovaBoxAuctionCard.types'

const props = defineProps<NovaBoxAuctionCardProps>()

// 상세 링크
const handleOnGoLink = () => {
  if (props.source.nttLinkAt === 'Y')
    useNavigations({
      external: props.source.nttExtrlLinkAt === 'Y',
      url: `${props.source.nttLinkUrl}`,
    })
}
</script>

<template>
  <article class="auction-vertical-card" @click="handleOnGoLink">
    <div class="auction-image-title">
      <NovaImageContainer
        :ratio="'1:1'"
        :image-url="source.cretnThumbFileUrl"
        class="auction-work"
      />
      <div class="title-wrap">
        <h4 class="title">{{ source.nttSj }}</h4>
      </div>
    </div>
    <div class="auction-contents">
      <div class="upper-area">
        <div class="name">
          <p class="nm">
            {{
              useFindLocaleByNamespace({
                nameSpace: 'crtrNm',
                model: source,
              })
            }}
          </p>
          <p class="lic-nm">
            {{
              useFindLocaleByNamespace({
                nameSpace: 'cretnLicNm',
                model: source,
              })
            }}
          </p>
        </div>
      </div>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.auction-vertical-card {
  cursor: pointer;
  border-radius: $radius-10;
  overflow: hidden;

  @media (hover: hover) {
    &:hover {
      .auction-image-title .auction-work {
        transform: scale(1.2);
      }
    }
  }

  .auction-image-title {
    position: relative;
    overflow: hidden;

    .auction-work {
      background-color: $color-bg-custom-2;
      @include transition(transform 0.2s ease-in-out);
    }

    .title-wrap {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
      width: 100%;
      height: 100%;
      padding: 15px;
      background: linear-gradient(
        180deg,
        hex-to-rgba($color-black, 0) 0%,
        hex-to-rgba($color-black, 0.2) 100%
      );

      > .title {
        text-align: right;
        font-size: 14px;
        font-weight: 700;
        color: $color-bg-3;
        text-shadow: 0 0 3px $color-dark-1;
        @include ellipsis(3);
        word-break: keep-all;
      }

      @include mobile {
        padding: 10px;
      }
    }
  }

  .auction-contents {
    padding: 10px 15px;
    background-color: $color-bg-3;

    .name {
      display: block;
      align-items: center;
      justify-content: flex-start;
      .nm {
        font-size: 14px;
        color: $color-text-2;
        @include ellipsis(1);
      }
      .lic-nm {
        font-size: 14px;
        color: $color-text-3;
        @include ellipsis(1);
      }
    }

    .actions {
      display: flex;
      align-items: center;
      gap: 8px;
      padding-top: 10px;
    }
  }
}
</style>
